import * as React from "react";
import {
  Layout,
  Metatags,
  Header,
  Footer,
  Qualify,
} from "@ADC/components/Views";
import Steps from "@ADC/components/Pages/Apply/Steps";
import Faqs from "@ADC/components/Pages/Apply/Faqs";

const ApplyPage = () => {
  return (
    <Layout className="w-full h-full pt-[85px] lg:pt-32 desktop:pt-[150px] overflow-x-hidden">
      <Header />
      <Steps />
      <Qualify />
      <Faqs />
      <Footer />
    </Layout>
  );
};

export default ApplyPage;

export const Head = () => (
  <Metatags
    pageTitle="Apply for Debt Consolidation in Texas | Fast & Easy Process"
    metaTitle="Apply for Debt Consolidation in Texas | Fast & Easy Process"
    description="See if you qualify for debt consolidation in Texas and apply in just 2 minutes. Reduce your debt, lower monthly payments, and find a solution that works for you."
  />
);
